import { Button, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useOptions from 'hooks/useOptions';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import JWTLogin from 'views/components/authentication/JWTLogin';
import AuthFooter from 'views/components/cards/AuthFooter';
import Logo from 'views/components/Logo';
import AuthCardWrapper from 'views/layout/Wrappers/AuthCardWrapper';
import AuthWrapper from 'views/layout/Wrappers/AuthWrapper';

const Login = () => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const { patientRegistrationEnabled, permissions } = useOptions();
  const [is2faRequired, setIs2faRequired] = useState(false);

  const location = useLocation();

  const login2fa = (location.state as any)?.login2fa;
  const email = (location.state as any)?.username;
  const password = (location.state as any)?.password;

  useEffect(() => {
    if (login2fa) setIs2faRequired(true);
  }, [login2fa]);

  return (
    <AuthWrapper>
      <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  <Grid item sx={{ mb: 3 }}>
                    <Button>
                      <Logo size="lg" />
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container direction={matchDownMD ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                      <Grid item>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                          <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownMD ? 'h3' : 'h2'}>
                            <FormattedMessage defaultMessage="Welcome" />
                          </Typography>
                          <Typography variant="caption" fontSize="16px" textAlign={matchDownMD ? 'center' : 'left'}>
                            {!is2faRequired ? (
                              <FormattedMessage defaultMessage="Enter your email to continue" />
                            ) : (
                              <FormattedMessage defaultMessage="Enter your code to continue" />
                            )}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <JWTLogin is2faRequired={is2faRequired} setIs2faRequired={setIs2faRequired} email={email} password={password} />
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  {!permissions?.isRegister && (
                    <Grid display="flex" justifyContent="space-between" item xs={12} sm={12}>
                      <Grid item xs={12}>
                        {patientRegistrationEnabled && ( // providerRegistration
                          <Grid item container direction="column" alignItems="center" xs={12}>
                            <Link to="/register">
                              <Typography variant="subtitle1" color="secondary">
                                <FormattedMessage defaultMessage="Don't have an account?" />
                              </Typography>
                            </Link>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          <AuthFooter />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default Login;
